<template>
  <component :is="name" />
</template>

<script>
import Advertiser from './Advertiser/index.vue';
import Publisher from './Publisher/index.vue';
import BountyHunter from './BountyHunter/index.vue';
import BountyAdmin from './BountyAdmin/index.vue';

export default {
  components: { Advertiser, Publisher, BountyAdmin, BountyHunter },

  head: {
    title() {
      return {
        inner: this.$t('payments')
      };
    }
  },

  computed: {
    name() {
      const role = this.$store.getters.role.toLowerCase();
      return role === 'bounty-hunter' ? 'bountyHunter' : role;
    }
  }
};
</script>
